import React from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';
import { HdButton, HdPane } from '../../../components';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';

export function LastRunFailedRecordsMessagePane({
  className = '',
  activationSeqId,
  dataId
}: {
  className: string;
  activationSeqId: number;
  dataId: string;
}) {
  const dataIdGenerator = getDataIdGenerator(dataId);
  const history = useHistory();

  const openRecentHistory = () => {
    history.push(`/activation/${activationSeqId}/history?highlight=true`);
  };

  return (
    <HdPane className={className} variant='error-faded' icon='error-filled'>
      <div className='d-flex align-items-start'>
        <span className='text-body-2 flex-1'>
          We failed to synchronize some records in the last run. Click <b>View History</b> to know
          more.
        </span>

        <HdButton
          className='ml-4'
          size='sm'
          variation='outline'
          filledBg
          inlineText
          dataId={dataIdGenerator('view-history')}
          onClick={openRecentHistory}
        >
          View History
        </HdButton>
      </div>
    </HdPane>
  );
}
